import { ChartDef } from '@model-main/pivot/frontend/model/chart-def';

export const AxisTicksConfigMode = {
    NUMBER: ChartDef.AxisTicksConfig.AxisTicksConfigMode.NUMBER,
    INTERVAL: ChartDef.AxisTicksConfig.AxisTicksConfigMode.INTERVAL
};
